/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {savingsCashIn} from '../api'

export const useMutationSavingsCashIn = createReactQueryMutationHook('savingsCashIn', savingsCashIn)
